module.exports = __webpack_public_path__ + "static/media/app.282980d8.png";